import { DefaultService } from '@/services/DefaultService';

export default class LogIntegracaoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    getLogIntegracaoByEntidadeVendas(entidade, idregistro, page = 0, limit = 15, column, order, ...params) {
        return this._http.get(`${this._env}/ven/apiauditoria/logs-entidade.json?page=${page}&limit=${limit}&order=${order}&column=${column}&idregistro=${idregistro}
        &entidade=${entidade}&params=${params}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    getLogIntegracaoByEntidadeAgro(entidade, idregistro, page = 0, limit = 15, column, order, ...params) {
        return this._http.get(`${this._env}/agro/apiauditoria/logs-entidade.json?page=${page}&limit=${limit}&order=${order}&column=${column}&idregistro=${idregistro}
        &entidade=${entidade}&params=${params}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    deleteVendas(entidade, idregistro) {
		return this._http.delete(`${this._env}/ven/apiauditoria/logs-entidade/${entidade}/${idregistro}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    deleteAgro(entidade, idregistro) {
		return this._http.delete(`${this._env}/agro/apiauditoria/logs-entidade/${entidade}/${idregistro}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    getLogIntegracaoSync(entidade, idregistro, page = 0, limit = 15, column, order, ...params) {
        return this._http.get(`${this._env}/ven/synclogimportacao/logs.json?page=${page}&limit=${limit}&order=${order}&column=${column}&idregistro=${idregistro}
        &entidade=${entidade}&params=${params}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}